import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSoundsStore } from "../@shared/store/useSoundsStore";
import AudioManager from "../@shared/utils/AudioManager";
import { loadMusicFolderUrls } from "../@shared/utils/musicLibrary";

const shuffleArray = (arr) => {
  const next = [...arr];
  for (let i = next.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [next[i], next[j]] = [next[j], next[i]];
  }
  return next;
};

export default function MusicController() {
  const location = useLocation();
  const musicBank = useSoundsStore((s) => s.musicBank);
  const setMusicScreenUrls = useSoundsStore((s) => s.setMusicScreenUrls);
  const musicVolume = useSoundsStore((s) => s.musicVolume);
  const isMusicMuted = useSoundsStore((s) => s.isMusicMuted);

  useEffect(() => {
    let cancelled = false;

    const path = location.pathname.split("/")[1];
    const screenKey =
      {
        "": "dashboard",
        gameboard: "gameboard",
        lobby: "lobby",
        mycards: "mycards",
        // test: "test",
      }[path] || "dashboard";

    const playScreenMusic = async () => {
      const cachedUrls = musicBank[screenKey] || [];
      const urls =
        cachedUrls.length > 0
          ? cachedUrls
          : await loadMusicFolderUrls(screenKey).then((nextUrls) => {
              if (!cancelled) {
                setMusicScreenUrls(screenKey, nextUrls);
              }
              return nextUrls;
            });

      if (cancelled) return;

      AudioManager.stopMusic();

      if (isMusicMuted || urls.length === 0) return;

      AudioManager.playPlaylist(shuffleArray(urls), musicVolume);
    };

    playScreenMusic().catch((error) => {
      console.error("Failed to load background music:", error);
    });

    return () => {
      cancelled = true;
    };
  }, [location.pathname, musicBank, isMusicMuted, musicVolume, setMusicScreenUrls]);

  useEffect(() => {
    if (isMusicMuted) {
      AudioManager.stopMusic();
    } else {
      AudioManager.setMusicVolume(musicVolume);
    }
  }, [musicVolume, isMusicMuted]);

  return null;
}
